// hooks
import { useTranslation } from "react-i18next";

const CartSummary = ({ summary, cmplt_btn }) => {
    const [t, i18n] = useTranslation("global");
    return (
        <div className="cart-summary-container product-section-div">
            <h5 className="discount-div-title cart-title">
                {t("cart.summary")}
            </h5>
            <ul className="summary-ul">
                {summary.orders.map((i) => (
                    <li key={i.id} className="summary-order flex-between-row">
                        <span className="summary-order-title">
                            {i18n.language == "ar" ? i.ar.title : i.en.title}
                        </span>
                        <span className="summary-order-price">
                            {`${i.price} ${
                                i18n.language == "ar"
                                    ? summary.ar.currancy
                                    : summary.en.currancy
                            }`}
                        </span>
                    </li>
                ))}

                <li className="summary-total flex-between-row">
                    <span className="summary-total-title">
                        {t("cart.total")}
                    </span>
                    <span className="summary-order-price">
                        {`${summary.total} ${
                            i18n.language == "ar"
                                ? summary.ar.currancy
                                : summary.en.currancy
                        }`}
                    </span>
                </li>
            </ul>
            {cmplt_btn ? (
                <button className="ocean-btn summary-btn">
                    {t("cart.cmplt-order")}
                </button>
            ) : (
                ""
            )}
        </div>
    );
};

export default CartSummary;
